/*********************************************************************************************
* Initialize the sticky CTA behavior.
	*
*/
function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta] [data-hide]');

	// Vérifie que les éléments existent
	if (!classicCTA || !stickyCTA) {
		console.error("Les éléments [data-cta] ou [data-sticky-cta] n'existent pas.");
		return;
	}

	// Crée un observateur pour surveiller la visibilité du CTA principal
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				// Si le CTA principal n'est plus visible
				stickyCTA.classList.remove('mm-none');
			} else {
				// Si le CTA principal est visible
				stickyCTA.classList.add('mm-none');
			}
		});
	}, {
		root: null, // viewport par défaut
		threshold: 0 // détecter si n'importe quelle partie de l'élément est visible
	});

	// Lancer l'observation du CTA principal
	observer.observe(classicCTA);
}

/*********************************************************************************************
* Initialize the Splide carousel for the reassurance slider.
	*
*/
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputId) {
	let inputs = document.querySelectorAll(`#${inputId}`);
	let input = inputs[0];
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		inputs.forEach(function(elem) {
			elem.value = newValue;
		})

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
  var priceAll = document.querySelectorAll("[data-price]");
  var comparePriceAll = document.querySelectorAll("[data-compare-price]");

  // Met à jour les prix normaux
  priceAll.forEach(function (price) {
    var priceValue = parseFloat(price.dataset.price);
    if (!isNaN(priceValue)) {
      var total = (priceValue * qtty) / 100;
      price.innerHTML = formatPrice(total);
    } else {
      console.error("Valeur de prix non valide : ", price.dataset.price);
    }
  });

  // Met à jour les prix comparatifs
  comparePriceAll.forEach(function (comparePrice) {
    var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
    if (!isNaN(comparePriceValue)) {
      var total = (comparePriceValue * qtty) / 100;
      comparePrice.innerHTML = formatPrice(total);
    } else {
      console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
    }
  });

  // --- Met à jour la remise totale ---
  var unitPrice = priceAll.length ? parseFloat(priceAll[0].dataset.price) : NaN;
  var unitCompare = comparePriceAll.length ? parseFloat(comparePriceAll[0].dataset.comparePrice) : NaN;

  var savingsEls = document.querySelectorAll("[data-savings]");
  if (savingsEls && !isNaN(unitPrice) && !isNaN(unitCompare)) {
    var savingsPerUnit = Math.max(unitCompare - unitPrice, 0) / 100;
    var totalSavings = savingsPerUnit * qtty;

    if (totalSavings > 0) {
		savingsEls.forEach(function(savingsEl) {
			savingsEl.textContent = formatPrice(totalSavings) + " d’économies";
			savingsEl.hidden = false;
		})
    } else {
		savingsEls.forEach(function(savingsEl) {
		savingsEl.hidden = true;
		})
    }
  }
}

/**
 * Formate le prix : 
 * - supprime les décimales si inutile (4€)
 * - sinon affiche deux décimales (4,50€)
 */
function formatPrice(amount) {
  // Si c’est un entier, pas de décimales
  if (Number.isInteger(amount)) {
    return amount.toFixed(0) + "€";
  } else {
    // Sinon deux décimales, avec virgule française
    return amount.toFixed(2).replace('.', ',') + "€";
  }
}

/*********************************************************************************************
* Class for handling variant selection
	*
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		*
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
            this.variantFetch();

            // Add delay for single option products to ensure proper triggering
            setTimeout(() => {
                this.triggerImageChange();
            }, 10);
		}
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}


	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateMultipleElement(".mm-reload", html);

		// Reinitialize accordions after DOM update
		if (typeof initAccordions === 'function') {
			initAccordions();
		}
	}

	/*********************************************************************************************
	* Trigger image change event for the current variant.
		*
	*/
	triggerImageChange() {
		if (this.currentVariant) {
			let imageSrc = null;
			let imageId = null;

			if (this.currentVariant.featured_image) {
				imageSrc = this.currentVariant.featured_image.src;
				imageId = this.currentVariant.featured_image.id;
			} else if (this.currentVariant.image) {
				imageSrc = this.currentVariant.image.src;
				imageId = this.currentVariant.image.id;
			}

			const imageEvent = new CustomEvent('variantImageChange', {
				detail: {
					imageSrc: imageSrc,
					imageId: imageId,
					variant: this.currentVariant
				}
			});
			document.dispatchEvent(imageEvent);
		}
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        const destination = document.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination && source.length > 0 && destination.length > 0) {
            for (let index = 0; index < Math.min(source.length, destination.length); index++) {
                if (destination[index] && source[index]) {
                    destination[index].outerHTML = source[index].outerHTML;
                }
            }
        }
    }
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProductReassurance();
	initializeStickyCTA();
});


/*********************************************************************************************
 * Accordion
 */
function initAccordions() {
	const toggles = document.querySelectorAll("[data-accordion-toggle]");

	// Initialisation : masquer tous les "minus"
	toggles.forEach((toggle) => {
		const [plusIcon, minusIcon] = toggle.querySelectorAll("svg");
		minusIcon.style.display = "none";
	});

	toggles.forEach((toggle) => {
		toggle.addEventListener("click", function () {
			const targetId = toggle.getAttribute("data-accordion-toggle");
			const content = document.querySelector(`[data-accordion-content="${targetId}"]`);
			if (!content) return;

			const isOpen = content.classList.contains("open");
			const keepOthersOpen = toggle.hasAttribute("data-accordion-keep-open");

			if (!keepOthersOpen) {
				// Fermer tous les contenus sauf celui qu’on va potentiellement ouvrir
				document.querySelectorAll("[data-accordion-content]").forEach((el) => {
					if (el !== content) {
						el.classList.remove("open");
						el.style.maxHeight = null;
					}
				});

				toggles.forEach((t) => {
					const [pIcon, mIcon] = t.querySelectorAll("svg");
					if (t !== toggle) {
						pIcon.style.display = "inline";
						mIcon.style.display = "none";
					}
				});
			}

			// Toggle normal (ouvrir si fermé, fermer si ouvert)
			if (isOpen) {
				content.classList.remove("open");
				content.style.maxHeight = null;

				const [plusIcon, minusIcon] = toggle.querySelectorAll("svg");
				plusIcon.style.display = "inline";
				minusIcon.style.display = "none";
			} else {
				content.classList.add("open");
				content.style.maxHeight = content.scrollHeight + "px";

				const [plusIcon, minusIcon] = toggle.querySelectorAll("svg");
				plusIcon.style.display = "none";
				minusIcon.style.display = "inline";
			}
		});
	});

	// Si vous avez des éléments à ouvrir au chargement
	const elemsToOpenOnLoad = document.querySelectorAll("[data-open-on-load]");
	elemsToOpenOnLoad.forEach(function (elem) {
		elem.dispatchEvent(new Event("click"));
	});
}

document.addEventListener("DOMContentLoaded", function () {
	initAccordions();
});


document.addEventListener('focusin', e => {
	//console.log('FOCUS ON:', e.target);
});
